import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { YULAVA_EMAIL_ERROR, YulavaEmailError, yulavaEmailValidator } from './email-validator';

/**
 * Parte de configuración Formly para campos de email de visitantes:
 * validador bloqueante, mensajes traducidos y wrapper con la sugerencia.
 * Uso: fields.push({ ...base, ...yulavaEmailFormlyConfig(this.translateService) }).
 */
export function yulavaEmailFormlyConfig(
  translate: TranslateService
): Pick<FormlyFieldConfig, 'wrappers' | 'validators' | 'validation' | 'parsers'> {
  return {
    wrappers: ['email-suggestion'],
    // El valor guardado/enviado es el recortado (SPEC.md).
    parsers: [(value: any) => (typeof value === 'string' ? value.trim() : value)],
    validators: { validation: [yulavaEmailValidator] },
    validation: {
      messages: {
        [YULAVA_EMAIL_ERROR]: (error: YulavaEmailError) => {
          switch (error.reason) {
            case 'tld':
              return translate.instant('validarions.email_tld', { domain: error.domain });
            case 'provider':
              return translate.instant('validarions.email_provider', { domain: error.domain });
            default:
              return translate.instant('validarions.email_syntax');
          }
        },
      },
    },
  };
}
